import { createContext } from "react";

export interface IPKCE {
  pkceChallenge(length?: number): Promise<{
    code_challenge: string;
    code_verifier: string;
  }>;
  verifyChallenge(
    codeVerifier: string,
    expectedChallenge: string,
  ): Promise<boolean>;
  generateChallenge(codeVerifier: string): Promise<string>;
}

export const PKCEContext = createContext<IPKCE | undefined>(undefined);

export type PKCEProps = {
  pkce?: IPKCE;
};
